import { Box, Typography } from "@mui/material";
import I18n from "i18next";

import UsageReport from "./UsageReport";
import ReportActivityHistory from "../ReportActivityHistory";

const sx = {
  title: {
    color: "darkBlue.c100",
    marginBottom: "40px",
    pl: "10px"
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }
};

function ApiUsageReportsMain({
  data,
  pagination,
  historyPageNo,
  historyDialogOpen,
  closeHistoryDialogHandler,
  historyData,
  historyError,
  reportName,
  onHistoryPageChange,
  onDownload,
  onHistoryClick
}) {
  return (
    <Box>
      <Box sx={sx.headerContent}>
        <Typography variant="h4" sx={sx.title}>
          {I18n.t("reports.applicationOnboarding")}
        </Typography>
      </Box>
      <Box>
        <UsageReport rows={data} onDownload={onDownload} onHistoryClick={onHistoryClick} pagination={pagination} />
      </Box>
      <Box>
        {historyDialogOpen && (
          <ReportActivityHistory
            isOpen={historyDialogOpen}
            reportName={reportName}
            historyData={historyData}
            onClose={closeHistoryDialogHandler}
            onHistoryPageChange={onHistoryPageChange}
            historyPageNo={historyPageNo}
            historyError={historyError}
          />
        )}
      </Box>
    </Box>
  );
}

export default ApiUsageReportsMain;
